export default "__VITE_ASSET__CurRiIVX__"